export default __webpack_public_path__ + "static/14-unflod-51273e0567af28a1bb71e52fac272a11.png";